window.rxcTranslations = {
    en_US: {
        backToProductPage: 'Back - override label example',
    },
};
